import { useRef, useEffect } from 'react';
import { toCacheKey, trackAssociatedObjectsChangesClient } from '../api/trackAssociatedObjectsChangesClient';
import { delayUntilIdle } from '../helpers/delayUntilIdle';
export const useTrackAssociatedObjectsChanges = ({
  fromObjectTypeId,
  fromObjectId,
  toObjectTypeId,
  cardId,
  associationData
}) => {
  const lastRunObjectCoordsRef = useRef(undefined);
  useEffect(() => {
    if (associationData) {
      const objectCoords = toCacheKey(fromObjectTypeId, fromObjectId, toObjectTypeId, cardId);
      if (lastRunObjectCoordsRef.current !== objectCoords) {
        lastRunObjectCoordsRef.current = objectCoords;
        delayUntilIdle(() => {
          trackAssociatedObjectsChangesClient.makeFetchWithOpts()(fromObjectTypeId, fromObjectId, toObjectTypeId, cardId, associationData).catch(() => {
            // Ignore errors
          });
        });
      } else {
        delayUntilIdle(() => {
          trackAssociatedObjectsChangesClient.syncIntoCache(Promise.resolve(associationData), fromObjectTypeId, fromObjectId, toObjectTypeId, cardId, associationData);
        });
      }
    }
  }, [associationData, cardId, fromObjectId, fromObjectTypeId, toObjectTypeId]);
};